import React from 'react'

type ColumnDividerProps = {
  /** Begin a drag-to-resize gesture. */
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void
  /** Stable hook for tests / layout assertions. */
  testId: string
  /** Accessible name, e.g. "Resize the variant panel". */
  label: string
}

/**
 * Vertical splitter between two layout columns. The bar carries a visible fill at
 * rest and a small rounded "handle" pill (three dots) so analysts can tell the
 * column is draggable left/right even without hovering; the bar/handle tint on
 * hover/active.
 */
const ColumnDivider: React.FC<ColumnDividerProps> = ({ onPointerDown, testId, label }) => (
  <div
    role="separator"
    aria-orientation="vertical"
    aria-label={label}
    title="Drag to resize"
    onPointerDown={onPointerDown}
    data-testid={testId}
    className="group bg-border-base hover:bg-brand-200 active:bg-brand-300 flex cursor-col-resize items-center justify-center transition-colors"
  >
    <span
      aria-hidden="true"
      className="bg-background-primary border-border-base group-hover:border-brand-400 pointer-events-none flex flex-col items-center gap-[3px] rounded-full border px-[3px] py-[6px] shadow-sm"
      data-testid={`${testId}-grip`}
    >
      {[0, 1, 2].map((i) => (
        <span key={i} className="group-hover:bg-brand-600 h-1 w-1 rounded-full bg-gray-500 transition-colors" />
      ))}
    </span>
  </div>
)

export default ColumnDivider
